/* ICONFIT 2026-09-22 v7.
   Pin model-viewer minimumRenderScale to 1 on the class that OWNS the setter.
   The registered element class only inherits it; assigning there does nothing.
   Do NOT rewrite canvas CSS: forcing the 2x draw size hides the jar, forcing
   clientWidth halves it. This setter only stops GPU-throttle downscale. */
(function () {
  'use strict';
  function pin() {
    try {
      var MV = customElements.get('model-viewer');
      if (!MV) return false;
      var C = MV;
      while (C && C !== Function.prototype) {
        var d = Object.getOwnPropertyDescriptor(C, 'minimumRenderScale');
        if (d && d.set) {
          C.minimumRenderScale = 1;
          return true;
        }
        C = Object.getPrototypeOf(C);
      }
    } catch (e) { /* never break the page */ }
    return false;
  }
  function boot() {
    if (pin()) return;
    customElements.whenDefined('model-viewer').then(function () {
      pin();
      setTimeout(pin, 500);
      setTimeout(pin, 2000);
    }).catch(function () {});
  }
  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  } catch (e) { /* never break the page */ }
})();
